import classNames from '@jd/jmtd-tools/es/classnames';
import PropTypes from 'prop-types';
import React from 'react'; // 下拉列表

export default function DropdownList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      height = _ref.height,
      width = _ref.width,
      maxHeight = _ref.maxHeight,
      minHeight = _ref.minHeight,
      minWidth = _ref.minWidth;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtd-dropdown-list', className),
    style: {
      minHeight: minHeight,
      maxHeight: maxHeight,
      height: height,
      minWidth: minWidth,
      width: width
    }
  }, children);
}
DropdownList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
DropdownList.defaultProps = {
  children: null,
  className: '',
  height: null,
  width: null,
  maxHeight: null,
  minHeight: null,
  minWidth: null
};